import { useState } from "react";
import { HelpCircle, X } from "lucide-react";

export const HelpTip = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const slug = title?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "info";
  return (
    <span className="relative inline-block">
      <button onClick={() => setOpen(!open)} className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors ml-1" data-testid={`help-tip-${slug}`}>
        <HelpCircle className="w-3.5 h-3.5 text-slate-500" />
      </button>
      {open && (
        <div className="absolute z-50 left-0 top-7 w-72 bg-white rounded-xl shadow-xl border p-4 text-left animate-in fade-in-0 slide-in-from-top-1">
          <div className="flex items-start justify-between mb-2">
            <h4 className="font-semibold text-sm text-slate-800">{title}</h4>
            <button onClick={() => setOpen(false)} className="p-0.5 rounded hover:bg-slate-100" data-testid={`help-tip-close-${slug}`}><X className="w-3.5 h-3.5 text-slate-400" /></button>
          </div>
          <div className="text-xs text-slate-600 leading-relaxed space-y-1.5">{children}</div>
        </div>
      )}
    </span>
  );
};
